import { useContext } from 'react';
import ConditionalTile from '~/constants/srp/ConditionalTile';
import InventoryContext from '~/context/srp/InventoryContext';

export function useHasNewCarTile(): boolean {
  const { inventory } = useContext(InventoryContext);

  return (
    inventory.data?.inventory?.conditionalTiles?.some(
      tile => tile.key === ConditionalTile.NewCarConfigurator
    ) ?? false
  );
}

export function useNewCarTileMetaData() {
  const { inventory } = useContext(InventoryContext);

  return inventory.data?.inventory?.conditionalTiles?.find(
    tile => tile.key === ConditionalTile.NewCarConfigurator
  )?.tileMetadata;
}
